var React = require('react');

function Comment02 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10,19l3.5,4L17,19h3.5a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2H6.5a2,2,0,0,0-2,2V17a2,2,0,0,0,2,2ZM8.5,8h10v2H8.5Zm0,4h7v2h-7Z","transform":"translate(-4.5 -3)","fill":"currentColor"}));
}

Comment02.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20"};

module.exports = Comment02;

Comment02.default = Comment02;
